import {
  ensureHighlight,
  ensureSvg4Everybody,
  ensureYandexShare,
  getHighlight,
  getSvg4Everybody,
  initFancyboxTriggers,
} from '../adapters/legacy-vendors.js';

export async function initBootstrap() {
  initFancyboxTriggers();

  await ensureSvg4Everybody().catch(() => null);
  const svg4everybody = getSvg4Everybody();
  if (typeof svg4everybody === 'function') {
    svg4everybody();
  }

  if (document.querySelector('pre code')) {
    await ensureHighlight().catch(() => null);
  }

  ensureYandexShare().catch(() => null);

  const highlight = getHighlight();
  if (highlight) {
    document.querySelectorAll('pre code').forEach((element) => {
      highlight.highlightElement(element);
      if (typeof highlight.lineNumbersBlock === 'function') {
        highlight.lineNumbersBlock(element);
      }
    });
  }
}
